// extracted by mini-css-extract-plugin
export default {"productGrid":"L1-z","centerLink":"M1-z","productSection":"N1-z","item":"O1-z","ctaButton":"P1-z"};